module.exports = __webpack_public_path__ + "static/media/Lamps-and-lights-fitting.312f3a03.jpg";